import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/partner/page';

export const Route = createFileRoute('/_app/settings/partner/')({
  component: Page,
});
